import GenericSvgIconWrapper, {
  GenericSvgIconWrapperProps,
} from "./genericSvgIconWrapper";

import React from "react";
import { SvgIcon } from "@material-ui/core";

const AiInsightsIconSVG = () => (
  <SvgIcon viewBox="0 0 24 24">
    <g transform="translate(0.5, 4)">
      <path
        d="M13.6341 1.19507C13.4094 0.268311 12.0913 0.26831 11.8666 1.19507L11.2482 3.74511C11.168 4.07599 10.9096 4.33433 10.5788 4.41456L8.02873 5.03291C7.10197 5.25764 7.10197 6.5757 8.02873 6.80042L10.5788 7.41877C10.9096 7.499 11.168 7.75735 11.2482 8.08823L11.8666 10.6383C12.0913 11.565 13.4094 11.565 13.6341 10.6383L14.2524 8.08823C14.3327 7.75735 14.591 7.499 14.9219 7.41877L17.4719 6.80042C18.3987 6.5757 18.3987 5.25764 17.4719 5.03291L14.9219 4.41456C14.591 4.33433 14.3327 4.07599 14.2524 3.74511L13.6341 1.19507Z"
        fill="#FFB446"
      />
      <path
        d="M6.21084 10.0944C6.07255 9.52409 5.26143 9.52409 5.12314 10.0944L4.74262 11.6637C4.69325 11.8673 4.53426 12.0263 4.33065 12.0756L2.76139 12.4561C2.19108 12.5944 2.19108 13.4056 2.76139 13.5438L4.33065 13.9244C4.53426 13.9737 4.69325 14.1327 4.74262 14.3363L5.12314 15.9056C5.26143 16.4759 6.07255 16.4759 6.21084 15.9056L6.59136 14.3363C6.64074 14.1327 6.79972 13.9737 7.00334 13.9244L8.57259 13.5438C9.1429 13.4056 9.1429 12.5944 8.57259 12.4561L7.00334 12.0756C6.79972 12.0263 6.64074 11.8673 6.59136 11.6637L6.21084 10.0944Z"
        fill="#FFB446"
      />
      <path
        d="M3.52389 1.0932C3.43314 0.718933 2.90084 0.718933 2.81009 1.0932L2.56037 2.12302C2.52797 2.25665 2.42364 2.36098 2.29002 2.39338L1.26019 2.6431C0.885925 2.73385 0.885925 3.26615 1.26019 3.3569L2.29002 3.60662C2.42364 3.63902 2.52797 3.74335 2.56037 3.87698L2.81009 4.9068C2.90084 5.28107 3.43314 5.28107 3.52389 4.9068L3.77361 3.87698C3.80601 3.74335 3.91034 3.63902 4.04397 3.60662L5.07379 3.3569C5.44806 3.26615 5.44806 2.73385 5.07379 2.6431L4.04397 2.39338C3.91034 2.36098 3.80601 2.25665 3.77361 2.12302L3.52389 1.0932Z"
        fill="#FFB446"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7591 0.820801C2.86282 0.393066 3.47116 0.393067 3.57488 0.820801L3.86027 1.99774C3.8973 2.15046 4.01654 2.26969 4.16925 2.30672L5.34619 2.59211C5.77392 2.69583 5.77392 3.30417 5.34619 3.40789L4.16925 3.69328C4.01654 3.73031 3.8973 3.84955 3.86027 4.00226L3.57488 5.1792C3.47116 5.60693 2.86282 5.60693 2.7591 5.1792L2.47371 4.00226C2.43668 3.84955 2.31745 3.73031 2.16473 3.69328L0.987791 3.40789C0.560057 3.30417 0.560057 2.69583 0.987791 2.59211L2.16473 2.30672C2.31745 2.26969 2.43668 2.15046 2.47371 1.99774L2.7591 0.820801Z"
        fill="#FFB446"
      />
    </g>
  </SvgIcon>
);

const AiInsightsIcon: React.FC<GenericSvgIconWrapperProps> = (props) => {
  return (
    <GenericSvgIconWrapper {...props}>
      <AiInsightsIconSVG />
    </GenericSvgIconWrapper>
  );
};

export default AiInsightsIcon;
